import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentRole, setCurrentRoleState] = useState(() => {
    try { return localStorage.getItem('smm_crm_current_role') || 'Admin'; }
    catch { return 'Admin'; }
  });

  const [currentUser, setCurrentUserState] = useState(() => {
    try {
      const s = localStorage.getItem('smm_crm_current_user');
      return s ? JSON.parse(s) : null;
    } catch { return null; }
  });

  const setCurrentRole = (role, user = null) => {
    const normalizedUser = user || { id: 'admin', name: 'Admin', email: '', role };
    setCurrentRoleState(role);
    setCurrentUserState(normalizedUser);
    try {
      localStorage.setItem('smm_crm_current_role', role);
      localStorage.setItem('smm_crm_current_user', JSON.stringify(normalizedUser));
    } catch {}
  };

  const updateCurrentUser = (partialData) => {
    setCurrentUserState(prev => {
      const updated = { ...prev, ...partialData };
      try { localStorage.setItem('smm_crm_current_user', JSON.stringify(updated)); } catch {}
      return updated;
    });
  };

  const clearRole = () => {
    setCurrentRoleState('Admin');
    setCurrentUserState(null);
    try {
      localStorage.removeItem('smm_crm_current_role');
      localStorage.removeItem('smm_crm_current_user');
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ currentRole, currentUser, setCurrentRole, clearRole, updateCurrentUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
